// @flow

import { nudgesUrl } from 'src/config';
import {
  createAuthenticatedHttpClient,
  localiseUrl
} from 'src/modules/seek-api-request';
import get from 'lodash/get';
import { isMobileUserAgent } from 'src/modules/chalice-user-agent/device-detect';
import { trackNudgeImpression } from 'src/modules/job-tracking';
import { parse as parseCookies } from 'cookie';

export const CLEAR_NUDGE_ERROR = 'CLEAR_NUDGE_ERROR';
const GET_NUDGES = 'GET_NUDGES';
export const DISMISS_NUDGE = 'DISMISS_NUDGE';
export const ANSWER_NUDGE = 'ANSWER_NUDGE';
export const POST_NUDGE_ANSWER_SUCCESS = 'POST_NUDGE_ANSWER_SUCCESS';
export const POST_NUDGE_ANSWER_ERROR = 'POST_NUDGE_ANSWER_ERROR';
export const NUDGE_IMPRESSION = 'NUDGE_IMPRESSION';

const initialState = {
  nudges: [],
  currentNudgeIndex: 0,
  nudgePostError: false
};

type State = {
  nudges: Array<NudgeType>,
  currentNudgeIndex: number,
  nudgePostError: boolean
};

type Actions =
  | typeof NUDGE_IMPRESSION
  | typeof GET_NUDGES
  | typeof DISMISS_NUDGE
  | typeof POST_NUDGE_ANSWER_SUCCESS
  | typeof POST_NUDGE_ANSWER_ERROR;

type Action = {
  type: Actions,
  payload?: {
    nudgeId?: string,
    position?: number,
    seekerId?: number,
    nudges?: Array<NudgeType>
  }
};

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case GET_NUDGES: {
      const nudges = get(action, 'payload.nudges');

      return {
        ...state,
        nudges
      };
    }

    case POST_NUDGE_ANSWER_SUCCESS: {
      return {
        ...state,
        currentNudgeIndex: state.currentNudgeIndex + 1
      };
    }

    case POST_NUDGE_ANSWER_ERROR: {
      return {
        ...state,
        nudgePostError: true
      };
    }

    case DISMISS_NUDGE: {
      return {
        ...state,
        nudges: []
      };
    }

    case CLEAR_NUDGE_ERROR: {
      return {
        ...state,
        nudgePostError: false
      };
    }

    default: {
      return state;
    }
  }
}
export const getNudges = ({ locale }: { locale: Locale }) => (
  dispatch: Function,
  getState: Function
) => {
  return createAuthenticatedHttpClient()
    .send({
      method: 'post',
      timeout: 2000,
      url: localiseUrl(locale, nudgesUrl),
      label: 'nudges',
      data: {
        firstName: getState().user.firstName
      }
    })
    .then(({ data }) => {
      dispatch({
        type: GET_NUDGES,
        payload: {
          nudges: data
        }
      });
    });
};

export const postNudgeResponse = ({
  nudgeId,
  ctaValue
}: {
  nudgeId: number,
  ctaValue: string
}) => (dispatch: Function, getState: Function) => {
  return createAuthenticatedHttpClient()
    .send({
      method: 'put',
      timeout: 2000,
      url: `${localiseUrl(getState().location.locale, nudgesUrl)}/${nudgeId}`,
      label: 'nudges-post',
      data: { value: ctaValue }
    })
    .then(() => {
      dispatch({ type: POST_NUDGE_ANSWER_SUCCESS });
    })
    .catch(() => {
      dispatch({ type: POST_NUDGE_ANSWER_ERROR });
    });
};

export const impressNudge = ({
  nudgeId,
  position
}: {
  nudgeId: string,
  position: number
}) => (dispatch: Function, getState: Function) => {
  const sessionId = parseCookies(document.cookie).JobseekerSessionId;

  trackNudgeImpression({
    seekerId: getState().user.seekerId,
    sessionId,
    device: isMobileUserAgent() ? 'mobile' : 'desktop',
    pageNumber: getState().location.pageNumber,
    nudgeId,
    position
  });

  dispatch({ type: NUDGE_IMPRESSION });
};

export const answerNudge = () => ({ type: ANSWER_NUDGE });
export const dismissNudge = () => ({ type: DISMISS_NUDGE });
